"use strict";

(function () {
  'use strict';

  angular.module('lr.core').constant('PropertyStateType', {
    /// Unknown state
    unknown: 0,
    /// Property Cleaning State
    cleaning: 1,
    /// Property Inspection State
    inspections: 2,
    /// Property Maintenance State
    maintenance: 3,
    /// Property Guest Stay State
    guest: 4,
    /// Property flagged for follow up
    flagged: 5
  }).constant('StateID', {
    InspectionStateID: 'InspectionStateID',
    CleaningStateID: 'CleaningStateID',
    MaintenanceStateID: 'MaintenanceStateID',
    GuestStateID: 'GuestStateID'
  }) /// Valid values for a property state
  .constant('PropertyStateValue', {
    /// Unknown state
    unknown: 0,
    /// The state's action is not needed (Really only applies to Maintenance State as it normally manually set)
    notNeeded: 1,
    /// Pending while waiting for another state to complete - not ready
    pending: 2,
    /// Ready for the state's action to be performed - this applies to inspections - ready
    readyFor: 3,
    /// The state's action is actively being performed
    inProgress: 4,
    /// The state's action is completed - complete
    complete: 5,
    /// The state's action failed or another issue occurred.
    flagged: 6,
    onHold: 7
  }) /// Valid values for a guest state
  .constant('GuestState', {
    /// Unknown state
    unknown: 0,
    /// Property is not occupied by a guest and it is not ready for a guest stay -- "red"
    unoccupiedNotReady: 1,
    /// Property is not occupied by a guest and it is ready for a guest stay -- "green"
    unoccupiedReady: 2,
    /// Property is currently occupied by a guest -- ??
    occupied: 3
  }) /// Valid values for the property flag states
  // LiveRez.Core.Enums.Reservations.PropertyFlagState
  .constant('PropertyFlagState', {
    /// Property is not flagged
    notFlagged: 0,
    /// Property is flagged
    flagged: 1
  }) // LiveRez.Core.Enums.Reservations.PropertyFlagReason
  .constant('PropertyFlagReason', {
    /// Property is not flagged
    //'Not Flagged': 0,
    /// Property is propertyDamaged
    'Property Damaged': 1,
    /// Property is missingItems
    'Missing Items': 2,
    /// Property is damagedItems
    'Damaged Items': 3,
    /// Property is dirty
    Dirty: 4
  }).constant('SupportedProviders', {
    None: 0,
    Kaba: 1,
    PointCentral: 2,
    LiveRez: 3,
    All: 7
  }).constant('automationEventTypes', {
    Unknown: 0,

    /*
     * Cleaning Events (1-25)
     */
    CleaningStarted: 1,
    CleaningCompletedSuccessfully: 2,
    CleaningCompletedWithProblems: 3,

    /*
     * Inspection Events (26-50)
     */
    InspectionStarted: 26,
    InspectionCompletedSuccessfully: 27,
    InspectionCompletedWithProblems: 28,

    /*
     * Maintenance Events (51-75)
     */
    MaintenanceStarted: 51,
    MaintenanceCompletedSuccessfully: 52,
    MaintenanceCompletedWithProblems: 53,

    /*
     * Flag Events (76-100)
     */
    PropertyFlagStarted: 76,
    PropertyFlagResolved: 77,

    /*
     * Door Events (101-125)
     */
    DoorOpened: 101,
    DoorClosed: 102,
    DoorBadCodeUsed: 103,

    /*
     * Thermostat Events (126-150)
     */
    ThermostatTempChanged: 126,
    ThermostatModeChanged: 127,
    ThermostatExtremeTempStarted: 128,
    ThermostatExtremeTempResolved: 129,

    /*
     * Hub Problems (151-200)
     */
    PowerLost: 151,
    PowerRestored: 152,
    BatteryLow: 153,
    BatteryRestored: 154,
    Malfunction: 155,
    MalfunctionResolved: 156,
    CommunicationsFailure: 157,
    CommunicationsRestored: 158
  }).constant('api', {
    proxy: 'proxy'
  }).constant('authNames', {
    cookie: 'lrauthtoken'
  }).constant('authEvents', {
    login: 'auth:login',
    success: 'auth:success',
    logout: 'auth:logout'
  }).constant('authErrors', {
    unauthorized: "You don't have access to use this Application. Please contact your system administrator.",
    // 401
    forbidden: 'Your information is incorrect.',
    // 403
    system: 'There was a system error, please try again.',
    // 500
    securityID: 'Please enter a valid Security ID.',
    username: 'Please enter a valid username.',
    password: 'Please enter a valid password.',
    notAuthenticated: 'User not authenticated.',
    noAccess: 'Security error, please contact support.'
  }).constant('eventTypes', {
    /// <summary>
    /// An unknown/unexpected event has occurred
    /// </summary>
    Unknown: 0,

    /*
     * Cleaning Events (1-25)
     */
    /// <summary>
    /// Cleaner has started cleaning (1)
    /// </summary>
    CleaningStarted: 1,
    /// <summary>
    /// Cleaner finished cleaning with no problems (2)
    /// </summary>
    CleaningCompletedSuccessfully: 2,
    /// <summary>
    /// Cleaner finished cleaning but there were problems (3)
    /// </summary>
    CleaningCompletedWithProblems: 3,
    CleaningCanceled: 4,

    /*
     * Inspection Events (26-50)
     */
    /// <summary>
    /// Inspector has started inspecting (26)
    /// </summary>
    InspectionStarted: 26,
    /// <summary>
    /// Inspector finished inspecting with no problems found (27)
    /// </summary>
    InspectionCompletedSuccessfully: 27,
    /// <summary>
    /// Inspector finished inspecting with problems found (28)
    /// </summary>
    InspectionCompletedWithProblems: 28,
    InspectionCanceled: 29,

    /*
     * Maintenance Events (51-75)
     */
    /// <summary>
    /// Vendor has started maintenance (51)
    /// </summary>
    MaintenanceStarted: 51,
    /// <summary>
    /// Vendor has completed maintenance with no remaining problems (52)
    /// </summary>
    MaintenanceCompletedSuccessfully: 52,
    /// <summary>
    /// Vendor has completed maintenance with problems still remaining (53)
    /// </summary>
    MaintenanceCompletedWithProblems: 53,
    MaintenanceCanceled: 54,

    /*
     * Flag Events (76-100)
     */
    /// <summary>
    /// Property Alert has been issued (76)
    /// </summary>
    PropertyFlagStarted: 76,
    /// <summary>
    /// Property Alert have been resolved (77)
    /// </summary>
    PropertyFlagResolved: 77,

    /*
     * Door Events (101-125)
     */
    /// <summary>
    /// Door was opened/unlocked (101)
    /// </summary>
    DoorOpened: 101,
    /// <summary>
    /// Door was closed/locked (102)
    /// </summary>
    DoorClosed: 102,
    /// <summary>
    /// Bad door code was used (103)
    /// </summary>
    DoorBadCodeUsed: 103,
    /// <summary>
    /// Door was improperly accessed - Essentially a keypad stored user accessed
    // the door not a system user so no auditing is possible. (104)
    /// </summary>
    DoorImproperAccess: 104,

    /*
     * Thermostat Events (126-150)
     */
    /// <summary>
    /// Thermostat target temperature was changed (126)
    /// </summary>
    ThermostatTargetTempChanged: 126,
    /// <summary>
    /// Thermostat mode has been changed (127)
    /// </summary>
    ThermostatModeChanged: 127,
    /// <summary>
    /// Thermostat ambient temperature has changed (128)
    /// </summary>
    ThermostatAmbientTempChanged: 128,
    /// <summary>
    /// Thermostat ambient temperature has reached an extreme temp (129)
    /// </summary>
    ThermostatExtremeTempStarted: 129,
    /// <summary>
    /// Thermostat ambient temperature has reached an normal temp again (130)
    /// </summary>
    ThermostatExtremeTempResolved: 130,
    /// <summary>
    /// THe fan mode on thermostat was changed (131)
    /// </summary>
    ThermostatFanModeChanged: 131,

    /*
     * Hub Problems (151-200)
     */
    /// <summary>
    /// Power lost to the hub (151)
    /// </summary>
    PowerLost: 151,
    /// <summary>
    /// Power restored to hub
    /// </summary>
    PowerRestored: 152,
    /// <summary>
    /// Battery low on the hub
    /// </summary>
    BatteryLow: 153,
    /// <summary>
    /// Battery restored on the hub
    /// </summary>
    BatteryRestored: 154,
    /// <summary>
    /// Malfunction detected on the hub
    /// </summary>
    Malfunction: 155,
    /// <summary>
    /// Malfunction resolved
    /// </summary>
    MalfunctionResolved: 156,

    /*
     * Guest Events (201-225)
     */
    /// <summary>
    /// Guest has checked in
    /// </summary>
    GuestCheckIn: 201,
    /// <summary>
    /// Guest has checked out
    /// </summary>
    GuestCheckOut: 202,
    /// <summary>
    /// Guest has checked out via Automated Process
    /// </summary>
    AutomatedGuestCheckOut: 203,
    /// <summary>
    /// LiveManager RTM Work Order Request
    /// </summary>
    WorkOrderRequestNew: 301,

    /*
     * Special Events (32700-32767 starting at end of range and going backwards)
     */
    /// <summary>
    /// An event has occurred that we don't specifically track
    // but might track in the future (Default option for the rules engine)
    /// </summary>
    Other: 32766,
    /// <summary>
    /// We have decided to ignore these provider events for one reason or another
    /// </summary>
    Ignore: 32767
  });
})();